/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Achievement_Three_Months_HintInputs */

const en_us2_achievement_three_months_hint = /** @type {(inputs: Achievement_Three_Months_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 months of steady training`)
};

const pt_br2_achievement_three_months_hint = /** @type {(inputs: Achievement_Three_Months_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 meses treinando com constância`)
};

const es_419_achievement_three_months_hint = /** @type {(inputs: Achievement_Three_Months_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 meses entrenando con constancia`)
};

const pt_pt2_achievement_three_months_hint = /** @type {(inputs: Achievement_Three_Months_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 meses a treinar com regularidade`)
};

const fr_fr2_achievement_three_months_hint = /** @type {(inputs: Achievement_Three_Months_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 mois d'entraînement régulier`)
};

const de_de2_achievement_three_months_hint = /** @type {(inputs: Achievement_Three_Months_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 Monate konstantes Training`)
};

const it_it2_achievement_three_months_hint = /** @type {(inputs: Achievement_Three_Months_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 mesi di allenamento costante`)
};

/**
* | output |
* | --- |
* | "3 months of steady training" |
*
* @param {Achievement_Three_Months_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const achievement_three_months_hint = /** @type {((inputs?: Achievement_Three_Months_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Achievement_Three_Months_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_achievement_three_months_hint(inputs)
	if (locale === "es-419") return es_419_achievement_three_months_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_achievement_three_months_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_achievement_three_months_hint(inputs)
	if (locale === "de-DE") return de_de2_achievement_three_months_hint(inputs)
	if (locale === "it-IT") return it_it2_achievement_three_months_hint(inputs)
	return en_us2_achievement_three_months_hint(inputs)
});
export { achievement_three_months_hint as "achievement.three_months_hint" }